'use strict'

import Vue from 'vue'
import axios from 'axios'
import store from '../store/store'
import router from '../router'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  baseURL: 'https://www.atschool.co.nz/api/v2/'
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

const token = store.state.token
if (token) {
  _axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

_axios.interceptors.response.use(undefined, (err) => { // Check if the token has expired - if it has, logout
  return new Promise((resolve, reject) => {
    let error = err.response
    let errorMsg = 'Your session has expired. Please log in again.'

    if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
      store.commit('auth_error')
      if (typeof error.data.error !== 'undefined') {
        errorMsg = error.data.error
      }
      store.commit('error_message', errorMsg)
      store.dispatch('logout')
        .then(() => {
          router.replace('/login')
        })
    } else if (error.status === 500 && error.config && !error.config.__isRetryRequest) { // Retry on http 500 error
      var config = error.config
      // If config does not exist or the retry option is not set, reject
      // if (!config || !config.retry) reject(error);
      if (!config.retry) {
        config.retry = 3
      }

      // Set the variable for keeping track of the retry count
      config.__retryCount = config.__retryCount || 0

      // Check if we've maxed out the total number of retries
      if (config.__retryCount >= config.retry) {
        reject(error)
      } else if (config.__retryCount === config.retry) {
        config.__isRetryRequest = true
      } else {
        // Increase the retry count
        config.__retryCount += 1
        // Retry
        resolve(this.$http(err.config))
      }
    }
    throw err
  })
})

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
